<template>
    <AutoComplete inputClass="form-control" inputStyle="padding: 0.375rem 0.75rem;" v-model="school" type="search" :suggestions="filteredItems" @item-select="selected($event)" @complete="search($event)" field="name">
        <template #item="slotProps">

            <b>{{slotProps.item.name}}</b><br>
            <small class="text-muted">{{slotProps.item.street}}, {{slotProps.item.zip}} {{slotProps.item.local}}</small>
        </template>
        <template #header="footer">
            <small class="text-muted">Daten aus den Schulverzeichnissen der Statistischen Landesämter von jedeSchule.org</small>
        </template>
    </AutoComplete>
    <input type="hidden" :name="name" :value="school_string">

</template>

<script>
import AutoComplete from'primevue/autocomplete';

export default {
    components: {
        AutoComplete,
    },
    computed: {
        // a computed getter
        school_string: function () {
            if(typeof this.school !== 'string' && this.school !== null){
                return this.school.name
            }
            return this.school;
        }
    },
    props: {
        name: {
            type: String,
            required: true
        },
        value:{
            type: String,
            required:false
        },
        id:{
            type: String,
            required:false
        },
        scopeState:{
            type: String,
            required:false
        }
    },
    mounted() {
        this.school=this.value;
    },
    methods: {
        selected(event) {
            if (typeof this.school !== 'string') {
                this.$emit('selected',this.school);
                if(this.school.street && document.querySelector('input[data-type-hint=street]')){
                    document.querySelector('input[data-type-hint=street]').value=this.school.street;
                }
                if(this.school.zip && document.querySelector('input[data-type-hint=zip]')){
                    document.querySelector('input[data-type-hint=zip]').value=this.school.zip;
                }
                if(this.school.local && document.querySelector('input[data-type-hint=local]')){
                    document.querySelector('input[data-type-hint=local]').value=this.school.local; }
                if(this.school.state && document.querySelector('input[data-type-hint=state]')){
                    document.querySelector('input[data-type-hint=state]').value=this.school.state; }
                if(this.school.state && document.querySelector('select[data-type-hint=state]')){
                    document.querySelector('select[data-type-hint=state]').value=this.school.state; }


            }

        },

        search(event) {

            //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
            let query = event.query;
            let scope_state = '';
            if(this.scopeState){
                scope_state='&state='+this.scopeState;
            }
            axios.get('/schulen/suche?q='+query+scope_state )
                .then((resp)=> {
                    this.filteredItems=resp.data;
                })
                .catch( (error)=> {
                    error="Leider konnten die Labels nicht gespeichert werden."
                });

        }
    },
    data() {
        return {
            filteredItems: null,
            school:null,

        }
    }
}
</script>
<style src="primevue/resources/themes/bootstrap4-light-blue/theme.css" ></style>

<style scoped>
.p-disabled, .p-component:disabled{
    opacity: 1;
}
.p-inputwrapper{
    display:block;
    width: 100%;
}

.p-autocomplete-input{
    padding: 0.375rem 0.75rem;
    width: 100%;

}
</style>

